// ScrollContext.tsx
import React, { createContext, useContext, useState } from "react";

type ScrollContextType = {
    scrollEnabled: boolean;
    setScrollEnabled: (value: boolean) => void;
};

const ScrollContext = createContext<ScrollContextType | undefined>(undefined);

export const ScrollProvider = ({ children }: { children: React.ReactNode }) => {
    const [scrollEnabled, setScrollEnabled] = useState(true);

    return (
        <ScrollContext.Provider value={{ scrollEnabled, setScrollEnabled }}>
            {children}
        </ScrollContext.Provider>
    );
};

export const useScrollControl = () => {
    const context = useContext(ScrollContext);
    if (!context) {
        throw new Error("useScrollControl must be used within a ScrollProvider");
    }
    return context;
};
